/**
 * Temporary solution for TIGHT DEADLINE, this service will be replaced by vuex later.
 *
 * This is a helper service to fetch and construct data list as BE return un-joined data (and ENTIRE rows),
 * FE should manage the data itself.
 */

import includes from 'lodash/includes'
import get from 'lodash/get'

import server from './server'
import auth from './auth'
import moment from 'moment'
import toastr from './toastr'

const helper = {
  initData: async () => {
    let assignments = await server.get('/ops/getCleanerAssignments_byUACode/jwtCode').then(resp => resp.data.msgContent.data)
    let zones = await server.post('/proxy/cocos/getZones').then(resp => resp.data.msgContent.data)
    let stations = await server.post('/proxy/cocos/getStations').then(resp => resp.data.msgContent.data)
    let cars = await server.post('/proxy/cocos/getCars').then(resp => resp.data.msgContent.data.map(car => ({...car, UNLOCK: false})))
    let carInStations = await server.post('/proxy/cocos/getCarInStations').then(resp => resp.data.msgContent.data)
    // set USAC on user cookies
    let user = auth.getUser()
    if (assignments.length) {
      user['USER_ACCOUNT_CODE'] = assignments[0].USER_ACCOUNT_CODE
    } else {
      user['USER_ACCOUNT_CODE'] = ''
    }

    auth.setUser(user)

    return { assignments: assignments, zones: zones, stations: stations, cars: cars, carInStations: carInStations }
  },
  filterStationsAndCars: (assignments, carInStations, stations, cars) => {
    // only show stations and cars that assigned to logged in user
    carInStations = carInStations.filter(obj => {
      let tmp = assignments.find(assignment => assignment.CAR_IN_STATION_CODE === obj.CODE)
      if (tmp) {
        return obj
      }
    })
    stations = stations.filter(obj => {
      let tmp = carInStations.find(cist => cist.STATION_CODE === obj.CODE)
      if (tmp) {
        return obj
      }
    })
    cars = cars.filter(obj => {
      let tmp = carInStations.find(cist => cist.CAR_CODE === obj.CODE)
      if (tmp) {
        let assignment = assignments.find(assignment => assignment.CAR_IN_STATION_CODE === tmp.CODE)
        if (assignment) {
          Object.assign(obj, {STATION_CODE: tmp.STATION_CODE, CIST_CODE: tmp.CODE, NOTE: assignment.NOTE})
          return obj
        }
      }
    })
    return { stations: stations, cars: cars }
  },
  uploadFile: (file) => {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('image',file)
      server.post('/sso/fileUpload/Pic_CL', formData).then(
        resp => {
          if (resp) {
            resolve(resp.data.msgContent.fileUrl)
          } else {
            reject('Upload Error')
          }

        },
        err => {
          reject(err)
        }
      ).catch(err => reject(err))
    })
  },
  getCleanerHistory: async (filter) => {
    let historyUrl = ''
    let today = moment().format('YYYY-MM-DD')

    if (filter === 'today') {
      historyUrl = `/ops/rptCleaningLogs_Cleaner/1/jwtCode/${today}`
    } else if (filter === 'weekly') {
      historyUrl = `/ops/rptCleaningLogs_Cleaner/2/jwtCode/${today}`
    } else {
      let month = moment().format('YYYY-MM')
      historyUrl = `/ops/rptCleaningLogs_Cleaner/3/jwtCode/${month}`
    }
    let histories = await server.get(historyUrl).then(resp => resp.data.msgContent.data)
    let stations = await server.post('/proxy/cocos/getStations').then(resp => resp.data.msgContent.data)
    let cars = await server.post('/proxy/cocos/getCars').then(resp => resp.data.msgContent.data)
    let carInStations = await server.post('/proxy/cocos/getCarInStations').then(resp => resp.data.msgContent.data)
    carInStations = await composeCIST(cars,stations,carInStations)
    // histories = histories.map(history => ({ ...history, CIST: carInStations.find(cist => cist.CODE === history.CAR_IN_STATION_CODE) || {STATION: null, CAR: null} }))

    histories = histories.map(history => {
      let cistTmp = carInStations.find(cist => cist.CODE === history.CAR_IN_STATION_CODE)
      if (cistTmp !== undefined) {
        return {...history, CIST: cistTmp}
      } else {
        return { ...history, CIST: {CAR: {}, STATION: {}} }
      }
    })
    return { histories: histories }
  },
  getCleaningLogs: async () => {
    let logs = await server.get('/ops/getCleaningLogs').then(resp => resp.data.msgContent.data)
    let zones = await server.post('/proxy/cocos/getZones').then(resp => resp.data.msgContent.data.map(zone => ({...zone, COLLAPSED: true})))
    let stations = await server.post('/proxy/cocos/getStations').then(resp => resp.data.msgContent.data.map(station => ({...station, COLLAPSED: true})))
    let cars = await server.post('/proxy/cocos/getCars').then(resp => resp.data.msgContent.data)
    let carInStations = await server.post('/proxy/cocos/getCarInStations').then(resp => resp.data.msgContent.data)

    carInStations = await composeCIST(cars,stations,carInStations)

    // combine logs with CIST
    logs = logs.map(log => ({...log, CIST: carInStations.find(cist => cist.CODE === log.CAR_IN_STATION_CODE)}))
    return {zones: zones, stations: stations, cars: cars, carInStations: carInStations, logs: logs}
  },
  getHistoryByCleaner: async (type, date, uaCode) => {
    let historyUrl = ''

    if (type === 0) {
      historyUrl = `/ops/rptCleaningLogs_Cleaner/1/${uaCode}/${date}`
    } else if (type === 1) {
      historyUrl = `/ops/rptCleaningLogs_Cleaner/2/${uaCode}/${date}`
    } else {
      historyUrl = `/ops/rptCleaningLogs_Cleaner/3/${uaCode}/${date}`
    }
    let histories = await server.get(historyUrl).then(resp => resp.data.msgContent.data)
    let { cars, stations, carInStations } = await getBasicData().then(resp => resp)

    carInStations = await composeCIST(cars,stations,carInStations)

    histories = histories.map(history => {
      let cistTmp = carInStations.find(cist => cist.CODE === history.CAR_IN_STATION_CODE)
      if (cistTmp !== undefined) {
        return {...history, CIST: cistTmp}
      } else {
        return { ...history, CIST: {CAR: {}, STATION: {}} }
      }
    })
    return { histories: histories }
  },
  whiteListedUser: () => {
    let user = auth.getUser()
    let whitelist = [
      // 'lgfuad13@ymail.com'
      // 'yndgold@gmail.com'
    ]
    return includes(whitelist, user.USER_NAME)
  }
}

/**
 * Get cars, stations, and cist data from cocos.
 * @return {Array}
 */
async function getBasicData() {
  let stations = await server.post('/proxy/cocos/getStations').then(resp => resp.data.msgContent.data)
  let cars = await server.post('/proxy/cocos/getCars').then(resp => resp.data.msgContent.data)
  let carInStations = await server.post('/proxy/cocos/getCarInStations').then(resp => resp.data.msgContent.data)

  return {stations: stations, cars: cars, carInStations: carInStations}
}

/**
 * Join car and station into cist
 * @param  {Array} cars
 * @param  {Array} stations
 * @param  {Array} carInStations
 * @return {Array}
 */
function composeCIST(cars, stations, carInStations) {
  return new Promise((resolve) => {
    carInStations.forEach(cist => {
      let station = stations.find(station => station.CODE === cist.STATION_CODE) || {}
      let car = cars.find(car => car.CODE === cist.CAR_CODE) || {}
      Object.assign(cist, {CAR: car, STATION: station})
    })
    resolve(carInStations)
  })
}

export default helper
